import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetDids({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/did/list",
        params: {
          order_by: list.order_by,
          order_dir: list.order_dir,
          page: list.page || 0,
          did: list.did ? '*' + list.did + '*' : null,
          company_name: list.company_name ? `*${list.company_name}*` : null,
          vendor_name: list.vendor_name ? `*${list.vendor_name}*` : null,
          vendor_type: list.type || '',
          vendor_uuid: list.vendorId || '',
          reseller_uuid: list.resellerId || '',
          has_vendor: list.has_vendor === false ? 'false' : '',
          per_page: list.per_page || 10,
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  AddDid({ commit }, did) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did",
        data: did.did,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  DeleteAllDids({ commit }) {
    return new Promise(resolve => {
      axios({
        url: "/did/mass_delete",
        method: "DELETE"
      }).then(res => {
        resolve();
      });
    });
  },
  DeleteSelectedDids({ commit }, dids) {
    return new Promise(resolve => {
      axios({
        url: "/did/mass_delete",
        data: { "items": dids },
        method: "DELETE"
      }).then(res => {
        resolve();
      });
    });
  },
  GetSuppressionNumbers({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/suppressed_number/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page,
          number: list.number ? '*' + list.number + '*' : ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  AddSuppressionNumber({ commit }, suppression) {
    return new Promise(resolve => {
      axios({
        url: "/suppressed_number",
        data: suppression.suppression,
        method: "POST"
      }).then(res => {
        resolve();
      });
    });
  },
  DeleteSuppressionNumber({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/suppressed_number/" + id,
        method: "DELETE"
      }).then(res => {
        resolve();
      });
    });
  },
};

// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
